import { useInitData, useUserData } from '../../../../../hooks'
import { AppointmentFormModal, AppointmentType } from '../../../../Appointment'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { isRequestProfileAppointmentAvailable } from '../../RequestProfileHeaderFooter.utils'

export function useRequestProfileScheduleAppointmentAction() {
  const { availableSections } = useInitData()

  const userData = useUserData()

  const { handleCloseModal, outboundUuid, requestData, setModal } =
    useRequestProfileContext()

  const isAppointmentAvailable = isRequestProfileAppointmentAvailable({
    availableSections,
    outboundUuid,
    requestData,
    userData,
  })

  // The request's address is its building's, as in the Address widget (CAL-02 §7.3)
  function handleClickScheduleAppointment() {
    setModal(
      <AppointmentFormModal
        location={requestData?.building?.address?.value}
        request={requestData}
        type={AppointmentType.onSite}
        onClose={handleCloseModal}
      />
    )
  }

  return { handleClickScheduleAppointment, isAppointmentAvailable }
}
